const actions = {
  async translateText({ commit }, params) {
    const res = await this.$repositories.translate.translateText(params)

    return res.data.data
  },
}
export default actions
